import { enLocaleNumberFormatter } from "utils";
import {
  getCampaignLeftDays,
  getCurrentDate,
  convertDateToStamp,
  getCampaignAvailableOnDate,
} from "utils/DateTimeUtils";
import { checkLanguages } from "utils/LanguageCheckUtil";
import {
  CAMPAIGN_TYPE_COUPON,
  CAMPAIGN_TYPE_EARNING,
  CAMPAIGN_TYPE_GENERAL_MESSAGE,
  CAMPAIGN_TYPE_TICKET,
} from "services/CampaignAPIHelper";
import i18n from "utils/I18n";
import { CMS_DATA_BASE_URL } from 'utils/Config';
import { openLoginPage } from "utils/SSOUtil"
import { navigateStack } from "./WeChatUtil";

export const checkIfStarted = (startDate) => {
  if (startDate === null || startDate === undefined || startDate === "") {
    return true;
  }
  const now = getCurrentDate();
  return now >= convertDateToStamp(startDate);
};
export const checkIfExpired = (endDate) => {
  if (endDate === null || endDate === undefined || endDate === "") {
    return false;
  }
  const now = getCurrentDate();
  return now >= convertDateToStamp(endDate);
};

function getTranslation(campaign) {
  let campaignDescription = campaign.name;
  let campaignPhoto = campaign.cover_photo_url;
  let campaignSquarePhoto = campaign.square_cover_photo_url;
  const { translations } = campaign;
  if (translations === null) {
    return { campaignDescription, campaignPhoto, campaignSquarePhoto };
  }
  const currentLanguage = i18n.language;
  for (let index = 0; index < translations.length; index++) {
    const translation = translations[index];
    const checkTranslationLanguage = checkLanguages(translation.language);

    if (currentLanguage === checkTranslationLanguage) {
      campaignDescription = translation.name || campaignDescription;
      campaignPhoto = translation.cover_photo_url || campaignPhoto;
      campaignSquarePhoto = translation.square_cover_photo_url || campaignPhoto;
    }
  }
  return { campaignDescription, campaignPhoto, campaignSquarePhoto };
}

function getBrandImage(brandSection) {
  if (brandSection === null) {
    return "";
  }
  // if (!brandSection.should_show_brand_section) {
  //   return "";
  // }
  return brandSection?.icon_url ?? "";
}

export function getActionButonText(campaignType, couponRequiredPoints, startDate) {
  if (
    campaignType === CAMPAIGN_TYPE_GENERAL_MESSAGE ||
    campaignType === CAMPAIGN_TYPE_EARNING
  ) {
    return null;
  }
  if (campaignType === CAMPAIGN_TYPE_COUPON) {
    if (!checkIfStarted(startDate)) {
      return i18n.t("campaignDetail:availableOn", {
        date: getCampaignAvailableOnDate(startDate),
      });
    }
    if (couponRequiredPoints === 0) {
      return i18n.t("home_get");
    }
    // let formatedPoints = i18n.toNumber(couponRequiredPoints);
    // const formatedPoints = numberFormatter(couponRequiredPoints);
    return i18n.t("home_redeem_with_points", { points: enLocaleNumberFormatter(couponRequiredPoints) });
  }
  if (campaignType === CAMPAIGN_TYPE_TICKET) {
    if (!checkIfStarted(startDate)) {
      return i18n.t("campaignDetail:availableOn", {
        date: getCampaignAvailableOnDate(startDate),
      });
    }
    if (couponRequiredPoints) {
      return i18n.t("home_redeem_with_points", { points: enLocaleNumberFormatter(couponRequiredPoints) });
    }
    return i18n.t("getTicket");
  }
  return null;
}

function getCampaignTag(campaign) {
  if (campaign.is_only_for_you) {
    return i18n.t("only_for_you_tag");
  }
  if (campaign.is_featured) {
    return i18n.t("featured_tag");
  }
  return null;
}

export const getBuyCouponData = (campaign) => {
  const data = {
    campaignID: campaign.id,
    enableStoreSelection: false,
    stores: [],
    title: "",
    points: 0,
    limit: 1,
  };
  const couponTemplate = campaign.coupon_campaign_type_coupon_template;
  if (couponTemplate) {
    data.enableStoreSelection = couponTemplate.should_use_in_store;
    data.stores = couponTemplate.applicable_stores;
    data.title = couponTemplate.name;
    data.customerStoreSelectionBehavior = couponTemplate?.should_use_in_store
      ? couponTemplate?.customer_store_selection_behavior
      : null;
    data.customerOnlineOfflineSelectionBehavior = couponTemplate?.show_online_offline_selection
      ? couponTemplate?.customer_online_offline_selection_behavior
      : null;
    data.points = campaign.coupon_campaign_type_required_points;
    data.limit = campaign.coupon_campaign_type_per_head_limit;
    const currentLanguage = i18n.locale;
    if (couponTemplate.translations) {
      couponTemplate.translations.forEach((item, index) => {
        const checkTranslationLanguage = checkLanguages(item.language);
        if (currentLanguage === checkTranslationLanguage) {
          data.title = item.name;
        }
      });
    }
  }
  return data;
};

function getCampaign(campaign) {
  const translation = getTranslation(campaign);
  const {
    campaignDescription,
    campaignPhoto,
    campaignSquarePhoto,
  } = translation;
  const leftDays = getCampaignLeftDays(campaign.end_date);
  const buyCouponData = getBuyCouponData(campaign);

  const isTicket = campaign.type === CAMPAIGN_TYPE_TICKET;
  const outOfStock = isTicket
    ? !campaign.ticket_total_stock
    : campaign.coupon_campaign_type_coupon_stock === 0;


  return {
    campaignId: campaign.id,
    campaignType: campaign.type,
    campaignDescription,
    campaignPhoto,
    campaignSquarePhoto,
    campaignIsOnlyForYou: campaign.is_only_for_you,
    campaignIsFeatured: campaign.is_featured,
    leftDays,
    outOfStock,
    campaignTag: getCampaignTag(campaign),
    brandImage: getBrandImage(campaign.brand),
    requiredPoints: (
      isTicket
        ? campaign.ticket_campaign_type_require_points_to_redeem
        && campaign.ticket_campaign_type_required_points
        : campaign.coupon_campaign_type_required_points
    ) || 0,
    campaignActionButtonAvaiable: checkIfStarted(campaign.start_date),
    campaignStartDate: campaign.start_date,
    campaignEndDate: campaign.end_date,
    buyCouponData,
    earnedStamps: campaign.earned_stamps,
    totalStamps: campaign.total_stamps,
  };
}

export const subHeaderLink = (headerLink) => {
  if (headerLink === null || headerLink === undefined) {
    return "";
  }
  const firstindex = headerLink.indexOf("<") + 1;
  const lastIndex = headerLink.indexOf(">");
  const link = headerLink.substring(firstindex, lastIndex);
  return link;
};

export const assembleCampaign = (campaigns) =>
  campaigns.map((campaign) => getCampaign(campaign));

export const errorMessageIfFailedToGetRewards = (response, error) => {
  const errorDetail =
    error?.response?.data?.detail ||
    error?.data?.detail ||
    response?.data?.detail;
  console.log('errorDetail:', errorDetail);
  if (errorDetail === 'Customer is not eligible to this campaign.') {
    return {
      errorMessage: i18n.t('campaignDetail:notEligibleToTheCampaign'),
      showToast: false,
    }      
  }
  if (
    errorDetail === 'Check-in location is not within designated radius.'
  ) {
    return {
      errorMessage: i18n.t('campaignDetail:invalidGPSLocation'),
      showToast: true,
    }     
  }
  if (errorDetail === 'Given qr code not valid.') {
    return {
      errorMessage: i18n.t('campaignDetail:invalidQRCode'),
      showToast: true,
    }
  }
  if (errorDetail === 'Desired coupons are sold out.') {
    return {
      errorMessage: i18n.t('campaignDetail:couponOutOfStock'),
      showToast: true,
    }
  }
  if (errorDetail?.includes('Exceed campaign')) {
    return {
      errorMessage: i18n.t('campaignDetail:reachLimit'),
      showToast: true,
    }
  }
  if (errorDetail?.includes('not available today')) {
    return {
      errorMessage: i18n.t('campaignDetail:blackoutLimit'),
      showToast: true,
    }
  }
  return{
    errorMessage: i18n.t('campaignDetail:reachLimit'),
    showToast: true,
  }
};

export const campaignListWithUpdatedEarnedStamp = (campaignList, payload) => {
  // payload should have campaignId and earnedCount
  const { campaignID, rewardStampCount } = payload;
  return campaignList.map((campaign) => {
    if (campaign.campaignId === campaignID) {
      return {
        ...campaign,
        earnedStamps:
          campaign.earnedStamps + rewardStampCount,
      };
    }
    return campaign;
  });
};

export const loginAndRedirectToCampaign = ({
  campaignId,
  isTicket,
  enableOtp,
  eventRequireCompleteRegistration=false,
}) => {
  openLoginPage({
    locale: i18n.language || "en",
    redirectTo: `/campaign/${campaignId}`,
    isEventRegister: isTicket,
    enableOtp: enableOtp,
    eventRequireCompleteRegistration: isTicket && eventRequireCompleteRegistration,
  })
}

export const handleGoRedeemPage = ({
  history,
  isLogin,
  campaign = {},
  goBackOnSuccess = false,
}) => {
  const {
    campaignID: campaignId,
    campaignType,
    ticket,
  } = campaign;

  if (![
    CAMPAIGN_TYPE_COUPON,
    CAMPAIGN_TYPE_TICKET
  ].includes(campaignType)) {
    return;
  };

  const isTicket = campaignType === CAMPAIGN_TYPE_TICKET;

  if (!isLogin) {
    loginAndRedirectToCampaign({
      campaignId,
      isTicket,
      enableOtp: ticket?.enableOtp,
      eventRequireCompleteRegistration: ticket?.requiredPoints > 0
    });
    return;
  }
  navigateStack({
    history,
    pathname: '/campaign/detail',
    state: {
      campaign: campaign,
      campaignID: campaignId,
      goBackOnSuccess,
    },
    search: `?campaignID=${campaignId}&goBackOnSuccess=${goBackOnSuccess}`,
  });
};

export const getShareCampaignUrl = (id) =>
  `${CMS_DATA_BASE_URL}/campaigns/${id}/sharing`;

export const getShareStoreUrl = (id) => 
  `${CMS_DATA_BASE_URL}/stores/${id}/sharing`;
